import React from 'react';
import UniqueImage from '../../assets/images/home/UF.png';
import UniqueImageDe from '../../assets/images/home/UFde.png';
import PouchImage from '../../assets/focusareas/pouch-in-hand.webp';
import FingerPrint from '../../assets/images/home/finger-print.webp';
import Granules from '../../assets/images/home/granules.webp';
import Arrows from '../../assets/images/home/arrows.webp';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useTranslation } from 'react-i18next';
import {
  SupportEnergyDesc1,
  SupportEnergyDesc2,
  UniqueHeading,
  UniqueSlide1Desc,
  UniqueSlide1Heading,
  UniqueSlide2Desc,
  UniqueSlide2DescLearnMore,
  UniqueSlide2Heading,
  UniqueSlide3Desc,
  UniqueSlide3Heading,
  WhyRiiseEyebrow,
  WhyRiiseHpTitle,
  WhyCard1Title,
  WhyCard1Body,
  WhyCard2Title,
  WhyCard2Body,
  WhyCard3Title,
  WhyCard3Body,
  LearnMoreArrow,
} from '../../Constants';
import { useSelector } from 'react-redux';
import { selectCurrentLanguage } from '../../features/langSlice';
import VeganComponent from './Vegan';
import CustomLink from '../CustomLink';

const Unique = ({ isFocusArea, heading }) => {
  const { t } = useTranslation();
  const selectedLang = useSelector(selectCurrentLanguage);

  const SLIDER_DATA = [
    {
      img: FingerPrint,
      title: t(UniqueSlide1Heading),
      description: t(UniqueSlide1Desc),
    },
    {
      img: Granules,
      title: t(UniqueSlide2Heading),
      description: t(UniqueSlide2Desc),
    },
    {
      img: Arrows,
      title: t(UniqueSlide3Heading),
      description: t(UniqueSlide3Desc),
    },
  ];

  if (!isFocusArea) {
    const CARDS = [
      {
        n: '01',
        accent: '#1a4a4a',
        title: t(WhyCard1Title),
        body: t(WhyCard1Body),
      },
      {
        n: '02',
        accent: '#5DCAA5',
        title: t(WhyCard2Title),
        body: t(WhyCard2Body),
      },
      {
        n: '03',
        accent: '#1a4a4a',
        title: t(WhyCard3Title),
        body: t(WhyCard3Body),
      },
    ];
    return (
      <div className="t-w-full" style={{ backgroundColor: '#f5f0e8' }}>
        <div className="t-max-w-[1200px] t-mx-auto t-px-5 md:t-px-10 t-pt-6 md:t-pt-14 t-pb-4 md:t-pb-8 md:t-text-center">
          <p
            className="!t-m-0 t-font-sans t-uppercase"
            style={{ fontSize: 10, letterSpacing: '1.5px', color: '#1a4a4a' }}
          >
            {t(WhyRiiseEyebrow)}
          </p>
          <h2
            className="!t-mt-1 !t-mb-0 t-font-serif t-font-normal t-text-[24px] md:!t-text-[30px] t-text-navy"
          >
            {t(WhyRiiseHpTitle)}
          </h2>
        </div>
        <div className="t-max-w-[1200px] t-mx-auto md:t-grid md:t-grid-cols-2 md:t-gap-10 md:t-items-end t-px-4 md:t-px-10 t-pb-0">
          <div className="t-flex t-flex-col t-gap-[10px] md:t-gap-4 md:t-pb-12">
          {CARDS.map((c) => (
            <div
              key={c.n}
              className="t-bg-white"
              style={{
                borderLeft: `4px solid ${c.accent}`,
                borderRadius: 14,
                padding: '18px 16px',
              }}
            >
              <p
                className="!t-m-0 t-font-sans t-uppercase"
                style={{ fontSize: 10, letterSpacing: '1.2px', color: '#aaaaaa' }}
              >
                {c.n}
              </p>
              <h3
                className="!t-mt-1 !t-mb-2 t-font-sans t-font-bold"
                style={{ fontSize: 15, color: '#1a2e2e' }}
              >
                {c.title}
              </h3>
              <p
                className="!t-m-0 t-font-sans"
                style={{ fontSize: 12, color: '#555555', lineHeight: 1.55 }}
              >
                {c.body}
                {c.n === '03' && (
                  <>
                    {' '}
                    <CustomLink
                      to="/ingredients/microgranule"
                      className="!t-text-secondary t-font-semibold"
                    >
                      {t(LearnMoreArrow)}
                    </CustomLink>
                  </>
                )}
              </p>
            </div>
          ))}
          </div>
          <img
            src={selectedLang === 'de' ? UniqueImageDe : UniqueImage}
            alt=""
            className="t-w-full md:t-max-w-[640px] t-mx-auto md:t-mx-0 md:t-ml-auto t-h-auto t-block md:t-self-end"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="t-flex t-flex-col t-w-[100vw] t-bg-quaternary">
      <div className="t-flex t-flex-col t-items-center t-gap-4 t-px-4 t-pt-4 t-max-w-[600px] t-mx-auto">
        <h2 className={`t-text-white t-text-[24px] md:t-text-[30px] t-text-center t-font-serif t-font-normal`}>
          {heading ? heading : t(UniqueHeading)}
        </h2>
        {isFocusArea && (
          <div className="t-flex t-flex-col t-gap-4 -t-mt-2">
            <p className="t-m-0 t-font-sans t-leading-4 t-text-white">{t(SupportEnergyDesc1)}</p>
            <p className="t-m-0 t-font-sans t-leading-4 t-text-white">{t(SupportEnergyDesc2)}</p>
          </div>
        )}
        <div className="t-flex t-flex-col t-gap-2">
          {SLIDER_DATA.map((item, i) => (
            <div className="t-mx-auto t-max-w-[90%]" key={'unique-slider-' + item.title}>
              <div className="t-w-full t-flex t-flex-col t-gap-1 t-bg-white t-rounded-lg t-p-4 t-overflow-hidden">
                <div className="t-flex t-items-center t-overflow-hidden t-w-full t-gap-1">
                  <img
                    src={item.img}
                    alt=""
                    className="t-flex-none !t-h-[10%] !t-w-[10%] sm:!t-h-[7%] sm:!t-w-[7%] t-object-cover"
                  />
                  <h5 className="t-m-0 t-text-navy t-text-left t-font-sans t-font-bold" style={{ boxSizing: 'border-box' }}>
                    {item.title}
                  </h5>
                </div>
                <p className="t-m-0 t-font-sans t-text-left t-text-navy/70">
                  {item.description}
                  {i === 1 && (
                    <span>
                      <CustomLink to="/ingredients/microgranule" className="!t-text-secondary">
                        {t(UniqueSlide2DescLearnMore)}
                      </CustomLink>
                    </span>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>

        <img
          src={isFocusArea ? PouchImage : selectedLang === 'de' ? UniqueImageDe : UniqueImage}
          alt=""
          className={`${isFocusArea && 't-w-[80%] -t-ml-16'} `}
        />
      </div>
      {!isFocusArea && <VeganComponent />}
    </div>
  );
};

export default Unique;
